module.exports = __webpack_public_path__ + "img/lab-6.dee7f776.png";